import React, { useEffect, useState } from "react";
import { TestIds } from "../home";
import { FylloLogin } from "react-library";
import { getAccessToken, setAccessToken } from "../../services/common.service";
import LocaleService from "../../services/locale.service";
import { useNavigate } from "react-router-dom";
import { Routes } from "../../routes";
import { useRecoilValue } from "recoil";
import { languageAtom } from "../../state/atoms/language.atom";

const Unauthorized: React.FC = () => {
  const queryParams = new URLSearchParams(window.location.search);
 
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [hasToken, setHasToken] = useState<boolean>(false);
  const accessToken = getAccessToken();

  const selectedLanguage = useRecoilValue(languageAtom);
  const navigate = useNavigate();

  /**
   * Event listeners
   */
  useEffect(() => {
    window.addEventListener("login-event", loginEventHandler);
    window.addEventListener("access-token-generated", accessTokenEventHandler);

    return () => {
      window.removeEventListener("login-event", loginEventHandler);
      window.removeEventListener("access-token-generated", accessTokenEventHandler); 
    };
  }, []);

  useEffect(() => {
    if (accessToken) {
      fetchLocales();
    }
  }, []);

  useEffect(() => {
    if(!isLoading && hasToken) {
      setTimeout(() => {
        navigate(`${Routes.home}?${queryParams.toString()}`);
      }, 500);
    }
  }, [isLoading, hasToken]);

  const fetchLocales = async () => {
    try {
      setIsLoading(true);
      const locales = await LocaleService.getLocales(selectedLanguage);
      if(locales) {
        setHasToken(true);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const loginEventHandler = (e: Event) => {
    const event = e as TLoginEvent;
    console.log("event", event.detail);
  };

  const accessTokenEventHandler = (e: Event) => {
    const event = e as TAccessTokenEvent;
    const [token, userId] = event.detail;
    setAccessToken(token);
    localStorage.setItem("farmUserId", userId);

    setTimeout(() => {
      fetchLocales();
    }, 100);
  };

  return (
    <div data-testid={TestIds.unauthorizedScreen}>
      {!isLoading && !hasToken && (
        <div className="p-2">
          <FylloLogin />
        </div>
      )}
    </div>
  );
};

export default Unauthorized;

/**
 * ================== TYPES ======================
 */

type TLoginEvent = Event & {
  detail: {
    for: "otp" | "login",
    message: string
  }
}

type TAccessTokenEvent = Event & {
  detail: string[];
}